import { styled } from '#/src/theme';

export const VertailuList = styled('ul')({
  margin: 0,
  padding: 0,
  paddingLeft: '1.3rem',
});
